module.exports = __webpack_public_path__ + "static/img/eye.26075975.png";